<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Sinalização Digital
            <router-link to="/app/machines/sazonal/">
              <l-button wide type="primary" round style="float: right; margin-right: 15px; margin-top: 5px">
                <span class="btn-label">
                  <i class="fa fa-plus"></i>
                </span>
                Criar
              </l-button>
            </router-link>
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtro = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; float: right; margin-right: 15px"></el-button>
          </h4>
        </div>
        <el-dialog center :visible.sync="filtro" title="Filtros">
          <card class="row">
              <!-- Tipo -->
            <div class="col-sm-12">
              <label class="col-sm-6">Máquina :</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="searchVM"
              >
                <el-option
                  v-for="option in vendMachine"
                  class="select-danger"
                  :value="option.id"
                  :label="option.location"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          </card>
          <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
          <button class="btn btn-success" @click="filtragem()">Filtrar</button>
        </el-dialog>
        <div class="table-responsive table-full-width" v-if="showTable">
          <el-table class="table-striped" :data="tableData" @sort-change="sorting" v-loading="loading" >
            <el-table-column label="Nome" property="title"  sortable/>
            <el-table-column label="Máquina" property="vm_location" />
            <el-table-column label="Data início" property="data_inicio"  sortable/>
            <el-table-column label="Data fim" property="data_fim"  sortable/>
            <el-table-column label="Ações" width="90">
              <div class="td-actions" data-v-abc55 slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Editar" placement="top-start">
                  <a
                    class="btn btn-warning btn-link btn-xs"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Deletar" placement="top-start">
                  <a
                    class="btn btn-danger btn-link btn-xs"
                    @click="deleteVoucher(props.$index, props.row)"
                  >
                    <i class="fa fa-close"></i>
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next,total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Dropdown,
  Button,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Select,
  DatePicker,
  TimeSelect,
  Option,
  Pagination,
  Tooltip,
  Tag,
  Loading
} from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Pagination.name]: Pagination,
    [Tooltip.name]: Tooltip,
    [Tag.name]: Tag
  },
  data () {
    return {
      filtro: false,
      vendMachine: [],
      searchVM: '',
      date_init: [],
      categories: [],
      category: '',
      sazonal: [],
      showTable: true,
      sazonalAPI: [],
      totalResults: 30,
      pesquisa: '',
      page: 1,
      pageSize: 10,
      order: false,
      loading: true,
      btnLoading: false,
      sord: '',
      companyList: []
    }
  },
  created() {
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  mounted () {
    this.getListCompany()

    const ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      this.getData(ciaID)
      this.getVM(ciaID)
    } else { 
      this.getData()
      this.getVM()
    }
  },
  computed: {
    tableData() {
      let sazonal = this.sazonal
      let dateConverted = sazonal.map(v => {
        let data_inicio, data_fim
        if (v.begin_date) {
          data_inicio = new Date(v.begin_date).toLocaleDateString('pt-br')
        }
        if (v.end_date) {
          data_fim = new Date(v.end_date).toLocaleDateString('pt-br')
        }
        return { ...v, data_inicio, data_fim, };
      });
      console.log('conver', dateConverted)
      return dateConverted
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      if (x.prop === "data_inicio") {
        x.prop = 'begin_date'
      }
      if (x.prop === 'data_fim') {
        x.prop = 'end_date'
      }
      this.sord = sinal + x.prop
      this.getData()
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/sazonal/${row.id}`);
    },
    getVM(id) {
      if (id) {
        this.$store.dispatch('machines/listSort', {sort: '?company=' + id}).then(resp =>{
          this.vendMachine = resp
        })

      } else {
        this.$store.dispatch('machines/list').then(resp =>{
          this.vendMachine = resp
        })
      }
    }, 
    getListCompany () {
      this.$store.dispatch("company/list").then(data => {
        this.companyList = data
        console.log('com', data)
      })
    },
    filtragem () {
      this.sazonal = this.sazonalAPI
      var date = []
      this.pesquisa = ''
      if (this.searchVM) {
        this.pesquisa = '&vm=' + this.searchVM
      }
      this.getData()
      this.filtro = false;
    },
    clearFiltro() {
      this.filtro = false;
      this.page = 1
      this.pesquisa = ''
      this.searchVM = ''
      this.date_init = []
      this.getData();
    },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      this.getData()
    },
    deleteVoucher (index, data) {
      console.log('dele', data)
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse Vídeo.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("sazonal/delete", { id: data.id }).then(() =>{
            swal.fire({
              title: "Pronto!",
              text: `Cupom excluído.`,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            }).then(result =>{
              this.getData()
            })
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `Vídeo não excluído.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    getData (id) {
      this.loading = true
      if (id) {
        this.$store.dispatch("sazonal/listSort", {sort: '?page_size=' + this.pageSize
          + '&page=' + this.page 
          + '&company=' + id + '&ordering=' + this.sord + this.pesquisa}).then(resp => {
              console.log('respos', resp)
          this.totalResults = this.$store.state.sazonal.page.count
          this.sazonal = resp
          this.sazonalAPI = resp
          this.loading = false
          this.tableData
        }).catch(err => console.log(err));

      } else {
        this.$store.dispatch("sazonal/listSort", {sort: '?page_size=' + this.pageSize
          + '&page=' + this.page + '&ordering=' + this.sord + this.pesquisa}).then(resp => {
              console.log('respos', resp)
          this.totalResults = this.$store.state.sazonal.page.count
          this.sazonal = resp
          this.sazonalAPI = resp
          this.loading = false
          this.tableData
        }).catch(err => console.log(err));
      }
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.el-pagination__total {
    float: right;
    text-align: end;
    font-weight: 400;
    color: #606266;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
